export default class Logger {
  constructor(prefix) {
    this.prefix = prefix ? `${prefix}` : `Client`;
  }

  info(...args) {
    console.log(`%c${this.prefix} INFO: `, "color: blue", ...args);
  }

  warn(...args) {
    console.warn(`%c${this.prefix} WARN: `, "color: orange", ...args);
  }

  error(...args) {
    console.error(`%c${this.prefix} ERROR: `, "color: red", ...args);
  }
}
